export interface Location {
  name: string;
  address: string;
  officePhone: string;
  mobilePhone: string;
  email: string;
}

export interface Service {
  id: string;
  title: string;
  titleAfrikaans: string;
  description: string;
  descriptionAfrikaans: string;
  image: string;
  icon: string;
}

export interface Obituary {
  id: string;
  name: string;
  dates: string;
  serviceDate: string;
  serviceLocation: string;
  image: string;
  tribute: string;
}

export interface BusinessInfo {
  name: string;
  nameAfrikaans: string;
  tagline: string;
  taglineAfrikaans: string;
  whatsappChannel: string;
  whatsappPhone: string;
  whatsappQr: string;
  email: string;
  emailAlt: string;
  locations: Location[];
  services: Service[];
  obituaries: Obituary[];
  agent: {
    name: string;
    phone: string;
    phoneAlt: string;
  };
  pricing: {
    individual: string;
    family: string;
  };
  social: {
    facebook: string;
  };
}

export const siteData: BusinessInfo = {
  name: 'Hess Funeral Services',
  nameAfrikaans: 'Hess Begrafnisdienste',
  tagline: 'Dignity. Compassion. Care.',
  taglineAfrikaans: 'Waardigheid. Respek en omgee.',
  whatsappChannel: 'https://whatsapp.com/channel/0029VbZDdM5KQujJGZs7UTFO0C',
  whatsappPhone: '+27780979889',
  whatsappQr: '/images/qr-whatsapp.png',
  email: 'hessfunerals@gmail.com',
  emailAlt: 'hessfuneralscam@gmail.com',
  locations: [
    {
      name: 'Grabouw',
      address: '44 Hoofweg, Grabouw, South Africa',
      officePhone: '021 023 0080',
      mobilePhone: '078 097 9889 or 073 054 2747',
      email: 'hessfunerals@gmail.com',
    },
    {
      name: 'Caledon',
      address: '6 Meul Straat, Caledon, South Africa',
      officePhone: '021 023 4665',
      mobilePhone: '082 053 3398 or 073 054 2747',
      email: 'hessfuneralscam@gmail.com',
    },
  ],
  agent: {
    name: 'Qinton Williams',
    phone: '061 629 8639',
    phoneAlt: '073 054 2747',
  },
  services: [
    {
      id: 'funeral',
      title: 'Funeral Services',
      titleAfrikaans: 'Begrafnisdienste',
      description: 'Dignified funeral services with compassion and care for your loved one.',
      descriptionAfrikaans: 'Waardige begrafnisdienste met medelyde en sorg vir u geliefde.',
      image: '/images/service-funeral.jpg',
      icon: 'coffin',
    },
    {
      id: 'cremation',
      title: 'Cremation Services',
      titleAfrikaans: 'Kremasies',
      description: 'Professional cremation services handled with the utmost respect.',
      descriptionAfrikaans: 'Profesionele kremasiedienste met die grootste respek hanteer.',
      image: '/images/service-cremation.jpg',
      icon: 'flame',
    },
    {
      id: 'gravestone',
      title: 'Gravestones & Memorials',
      titleAfrikaans: 'Grafstene',
      description: 'Beautiful, lasting memorials to honour and remember.',
      descriptionAfrikaans: 'Pragtige, blywende gedenktekens om te eer en te onthou.',
      image: '/images/service-gravestone.jpg',
      icon: 'gravestone',
    },
    {
      id: 'insurance',
      title: 'Funeral Cover Insurance',
      titleAfrikaans: 'Uitkeer Polisdekking',
      description: 'Financial peace of mind for your family with no waiting period.',
      descriptionAfrikaans: 'Finansiële gerusheid vir u familie sonder wagtydperk.',
      image: '/images/service-insurance.jpg',
      icon: 'shield',
    },
  ],
  obituaries: [
    {
      id: '1',
      name: 'In Loving Memory',
      dates: '1950 - 2026',
      serviceDate: 'Service details available upon request',
      serviceLocation: 'Grabouw Chapel',
      image: '/images/obituary-1.jpg',
      tribute: 'A beloved family member who touched many lives with kindness and grace.',
    },
    {
      id: '2',
      name: 'Remembered Forever',
      dates: '1965 - 2025',
      serviceDate: 'Service details available upon request',
      serviceLocation: 'Caledon Chapel',
      image: '/images/obituary-2.jpg',
      tribute: 'Forever in our hearts, your legacy of love continues.',
    },
  ],
  pricing: {
    individual: 'R105 per month',
    family: 'R127 per month',
  },
  social: {
    facebook: 'https://facebook.com/hessfuneralservices',
  },
};